<view-file *ngIf="documentSearchParams.identifierId" [parentCategory]="'Claim'" [searchParams]="documentSearchParams"
  [tabKey]="'Attachments'">
</view-file>